import { Locales } from '../enum/locales';
import { TLocales } from '../type/locales';
import { IAudioSurah } from '../interfaces/i-audio-surah';

export class AudioSurah {
  id: number;
  guid: string;
  slug: string;
  link: string;
  number: number;
  titleEn: string;
  titleAr: string;
  duration: string;
  url: string;
  fullLink: string;

  constructor(data: IAudioSurah, locale: TLocales | string = Locales.en) {
    this.id = data.id;
    this.slug = data.slug;
    this.guid = data.guid;
    this.link = data.link;
    this.number = data.number;
    this.titleEn = data.title_en;
    this.titleAr = data.title_ar;
    this.duration = data.duration;
    this.url = data.url;
    this.fullLink = `${data.link}${data.url}`;
  }
}
